import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { type InputRef, PlaceholderInput } from 'ui';
import { useUser } from 'features/auth';

type CommentPlaceholderFormValues = {
  comment?: string;
};

type P = {
  inputRef?: RefObject<InputRef | null>;
  onRequestInput: () => void;
};

const CreateCommentFormPlaceholder = ({ inputRef, onRequestInput }: P) => {
  const { t } = useTranslation();
  const { railsUserData } = useUser();

  return (
    <PlaceholderInput<CommentPlaceholderFormValues>
      content={{
        inputName: 'comment',
        label: t('Comment'),
        placeholder: t('Write comment...'),
      }}
      inputRef={inputRef}
      onRequestInput={onRequestInput}
      profilePhoto={railsUserData.profilePhoto}
    />
  );
};

export default CreateCommentFormPlaceholder;
